// @module MHI.TrackingInfo.TrackingInfo
define('MHI.TrackingInfo.TrackingInfo.View'
,	[
	'mhi_trackinginfo_trackinginfo.tpl'
	,	'Backbone'
	,	'PageType.Base.View'
	,	'MHI.TrackingInfo.TrackingInfo.Model'
	,	'MHI.TrackingList.View'
	,	'GlobalViews.Message.View'
	,	'Utils'
    ]
, function (
	mhi_trackinginfo_trackinginfo_tpl
	,	Backbone
	,	PageTypeBaseView
	,	TrackingInfoModel
	,	TrackingListView
	,	GlobalViewsMessageView
	,	Utils
)
{
    'use strict';

	// @class MHI.TrackingInfo.TrackingInfo.View @extends Backbone.View
	return PageTypeBaseView.PageTypeBaseView.extend({

		template: mhi_trackinginfo_trackinginfo_tpl

	,	initialize: function (options) {
		
	
			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			this.model = new TrackingInfoModel();
			this.trackingList=[]
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}
	,	beforeShowContent:function beforeShowContent(){
		this.getBreadcrumbPages = function () {
			return [{
				text: Utils.translate('Tracking'),
				href: '/tracking'
			}]
		}
		this.title = Utils.translate('Tracking');
		var self = this;
		self.childViews = {
			"Tracking.Info.List":function(){
				return new TrackingListView({
					trackingList:self.trackingList
				})
			}
		}
		self.events = {
			'submit form':'searchTracking',
			'blur #soNum':'toggleInput',
			'blur #poNum':'toggleInput'
		}
		return jQuery.Deferred().resolve()

		
	}
	,	toggleInput:function(e){
			e.preventDefault();
			var ele = $(e.target).attr('id');
			var input_val = $(e.target).val();
			if(ele == "soNum" && input_val){
				this.$('#poNum').prop('disabled',true)
			}else if(ele == "poNum" && input_val){
				this.$('#soNum').prop('disabled',true)
			}else{
				this.$('#poNum').prop('disabled',false)
				this.$('#soNum').prop('disabled',false)
			}

	}
	,	fetchModel:function fetchModel(docNum,zip,docType){
		var self = this;
		var trackingListView = self.getChildViewInstance('Tracking.Info.List');
		
		self.model.fetch({
			data:{
				docNum:docNum,
				zip:zip,
				docType:docType
			}
		}).done(function(result){
			
			trackingListView.options.trackingList = result;
			trackingListView.render();
			
		})
	}
	,	searchTracking: function (e){
		
		e.preventDefault();
		
		var soNum = this.$('#soNum').val();
		
		var poNum = this.$('#poNum').val();
		var zip = this.$('#zip').val();
		var docNum = soNum?soNum:poNum;
		var docType = "Sales Order";
		this.$('[data-type="alert-placeholder"]').html("");
		if((!poNum && !soNum) || !zip){
			
			var global_view_message = new GlobalViewsMessageView({
				message: 'Please enter SO or PO number with zipcode',
				type: 'error',
				closable: true
			});
			this.$('[data-type="alert-placeholder"]').html(
				global_view_message.render().$el.html()
			);
			return;
		}
		if(!soNum){
			docType = "Purchase Order"
		}
		this.fetchModel(docNum,zip,docType);
	}	
	,	events: {
			
			
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}
	
		//@method getContext @return MHI.TrackingInfo.TrackingInfo.View.Context
	,	getContext: function getContext()
		{
			//@class MHI.TrackingInfo.TrackingInfo.View.Context
			
			return {
				
			};
		}
	});
	
});
